<mat-card appearance="outlined" class="center-content">
    <div class="row justify-content-center align-items-center">
        <div class="col text-center">
            <img src="assets/img/barcode-scan.gif" alt="barcode" />
            <form autocomplete="off">
                <input 
                    [(ngModel)]="barcode" 
                    name="barcode" 
                    type="text" 
                    size="57" 
                    #inputBox 
                    class="form-control mt-3" 
                    (keyup)="onKeyUp($event)" 
                />
            </form>
        </div>
    </div>
</mat-card>
